import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { DEFAULT_FOLDER_TAG_COLOR, TAG_COLORS } from '../utils/constants';

export default function TagDialog({ open, value, colors = TAG_COLORS, defaultColor = DEFAULT_FOLDER_TAG_COLOR, onClose, onSelect }) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Folder Tag</DialogTitle>
      <DialogContent>
        <Stack direction="row" sx={{ flexWrap: 'wrap', gap: 1.25, py: 1 }}>
          {colors.map((tag) => {
            const selected = value === tag.value;

            return (
              <Button
                key={tag.value}
                variant={selected ? 'contained' : 'outlined'}
                onClick={() => onSelect(tag.value, { useDefault: false })}
                sx={{ minWidth: 92, justifyContent: 'flex-start', gap: 1 }}
              >
                <Box
                  sx={{
                    width: 14,
                    height: 14,
                    borderRadius: '50%',
                    bgcolor: tag.value,
                    flexShrink: 0,
                  }}
                />
                <Typography variant="body2" component="span">
                  {tag.label}
                </Typography>
                {selected ? <CheckIcon fontSize="small" sx={{ ml: 'auto' }} /> : null}
              </Button>
            );
          })}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onSelect(defaultColor, { useDefault: true })}>Use default</Button>
        <Button onClick={onClose} variant="contained">
          Done
        </Button>
      </DialogActions>
    </Dialog>
  );
}
